<template>
  <div>
 <v-item-group>
          <v-container>
            <div class="md:flex md:flex-wrap">
              <div
                class="md:w-1/2 overflow-hidden md:my-1"
                v-for="(item, n) in selection"
                :key="n"
              >
                <v-item v-slot="{ active, toggle }">
                  <v-card
                  dark
                    :color="active ? 'primary' : '#f8f8f8ff'"
                    class="md:w-full d-flex align-center border border-gray-800"
                    :height="height"
                    @click="toggle"
                  >
                    <v-scroll-y-transition>
                      <div
                        :class="active ? 'text-white' : 'text-gray-700'"
                        class="
                          pl-4
                          py-4
                          align-align-top
                          flex
                          font-bold
                        "
                      >
                        {{ item.title }}
                      </div>
                    </v-scroll-y-transition>
                  </v-card>
                </v-item>
              </div>
            </div>
          </v-container>
        </v-item-group>
  </div>
</template>

<script>
export default {
  props: ["height", "selection"],
};
</script>